import { useEffect, useState } from 'react';

import baseApi from '../../api/baseApi';

import { setErrorStatus } from '../../utils';
import { ERRORS } from '../../constants';

const useSearch = ({ searchPhrase, isFetchingFromSearchResult }) => {
    const [searchConfidence, setSearchConfidence] = useState('');
    const [phrase, onSearch] = useState(searchPhrase ?? '');
    const [debouncedPhrase, setDebouncedPhrase] = useState(phrase);
    const [results, setResults] = useState([]);
    const [isTyping, setIsTyping] = useState(false);
    const [isFetchingData, setIsFetchingData] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!phrase) {
            return;
        }
        const timeoutId = setTimeout(() => {
            if (!phrase) {
                return;
            }

            setDebouncedPhrase(phrase);
            setIsTyping(true);
        }, 300);

        return () => {
            setIsTyping(false);
            clearTimeout(timeoutId);
        };
    }, [phrase]);

    useEffect(() => {
        if (!debouncedPhrase || isFetchingFromSearchResult) {
            return;
        }
        const search = async () => {
            setIsFetchingData(true);
            setError(null);
            setResults([]);
            await baseApi
                .post('/search', { searchText: debouncedPhrase })
                .then((response) => {
                    setSearchConfidence(response.data.metadata.searchConfidence);
                    return response.data.data;
                })
                .then(setResults)
                .catch(error => {
                    if (!error?.response) {
                        setError(ERRORS.unhandled);
                    } else {
                        setErrorStatus(setError, error);
                    }
                    setResults([]);
                });
            setIsFetchingData(false);
        };
        search();

        return () => setIsFetchingData(false);
    }, [debouncedPhrase, isFetchingFromSearchResult]);

    return { searchConfidence, results, isTyping, isFetchingData, onSearch, error };
};

export default useSearch;
